import $ from 'jquery';
import debounce from 'debounce';

export default class ModalView {
  constructor({ model, el }) {
    this.$el = $(el);
    this.content = model.content;
    this.body = $(document.body);
    this._bindEvents();

    this.openModal = this.openModal.bind(this);
    this.centerModal = this.centerModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.resizeDebounced = debounce(this.centerModal.bind(this), 50);

    this.enterContent();
    this.openModal();
  }

  _bindEvents() {
    this.events = [
      $('.modal-close', this.$el).on('click.modal-view', event => this.closeModal(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.modal-view'));
  }

  enterContent() {
    if (this.content.title) {
      $('.modal-title', this.$el).text(this.content.title);
    }

    if (this.content.message) {
      $('.modal-message', this.$el).html(this.content.message);
    }

    if (this.content.button) {
      $('.modal-message', this.$el).append(`<p><span class='modal-close button'>${this.content.button}</span></p>`);
    }
  }

  centerModal() {
    const modalContentHeight = $('.modal-content', this.$el).outerHeight();
    const modalContentWidth = $('.modal-content', this.$el).outerWidth();

    if (modalContentHeight > $(window).height()) {
      $('.modal-content', this.$el).css({
        marginTop: 0,
        marginLeft: -(modalContentWidth / 2),
      });

      this.body.addClass('modal-overflow');
    } else {
      $('.modal-content', this.$el).css({
        marginTop: -(modalContentHeight / 2),
        marginLeft: -(modalContentWidth / 2),
      });

      this.body.removeClass('modal-overflow');
    }
  }

  openModal() {
    this.$el.addClass('active');

    setTimeout(() => this.$el.addClass('opening'),
      20);

    // If images are loaded after the modal is open, we may need to center/resize the modal
    $('img', this.$el).on('load.modal-view', () => {
      this.centerModal();
    });

    this.$el.addClass('open');
    this.centerModal();
    window.addEventListener('resize', this.resizeDebounced);

    this.body.on('keyup.modal', (e) => {
      if (e && (e.type === 'keyup') && (e.keyCode === 27)) {
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.body.off('keyup.modal');
    window.removeEventListener('resize', this.resizeDebounced);
    this.$el.removeClass('open');
    this.$el.removeClass('opening');
    this.$el.removeClass('active');
    this.body.removeClass('modal-overflow');
    $('img', this.$el).off('load.modal-view');

    this.events.push(this.$el.one('transitionend.modal-view', () => {
      this._unbindEvents();
    }));
  }
}
